import RpcService              from '@/core/services/Rpc/RpcService';
import type RpcResponse        from '@/core/services/Rpc/RpcResponse';
import type RpcDataPagination  from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort        from '@/core/services/Rpc/RpcDataSort';
import type Shipment from "@/domains/Shipments/Shipment";
import type Partner from "@/domains/Partners/Partner";
import type DateRange from "@/core/types/DateRange";

/**
 * DAO для работы с реализациями покупателю
 */
class ShipmentsToBuyerDAO {

  /**
   * Загружает одну реализацию покупателю по ID
   */
  static async get(id: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('shipmentsToBuyer.get', { id });
  }

  /**
   * Загружает список реализаций покупателю.
   *
   * NB: контроллер сейчас принимает только фильтр shipmentFromSeller
   * (id, updatedSinceExportToOnes, excludePartnersIds пока не проброшены
   * наружу) — но пагинация и сортировка на беке реальные.
   */
  static async getList(
    filters?: {
      id?: number,
      idPattern?: number;
      shipmentDocumentNumberPattern?: string,
      seller?: Partner,
      buyer?: Partner,
      period?: DateRange;
      shipmentFromSeller?: Shipment;
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort,
  ): Promise<RpcResponse> {

    return await RpcService.makeRequest(

      'shipmentsToBuyer.getList',
      {
        id:                            filters?.id,
        idPattern:                     filters?.idPattern,
        shipmentDocumentNumberPattern: filters?.shipmentDocumentNumberPattern,
        seller:                        filters?.seller ? { id: filters.seller.id } : undefined,
        buyer:                         filters?.buyer ? { id: filters.buyer.id } : undefined,
        period:                        filters?.period,
        shipmentFromSeller:            filters?.shipmentFromSeller ? { id: filters.shipmentFromSeller.id } : undefined,
      },
      pagination,
      sort,
    );
  }
}

export default ShipmentsToBuyerDAO;
